'use client'
import React, {useContext} from "react"
import {
  Box,
  useTheme,
  Typography,
  useMediaQuery, Chip,
} from "@mui/material"
import Grid from "@mui/material/Grid"
import {GLOBAL_PATHS} from "@/lib/globals"
import {TranslationContext} from "@/configs/context"


/**
 * Ce composant est un call to action de la page
 * @constructor
 */
const Cta2Wrapper: React.FC = () => {
  const theme = useTheme()
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))
  const matchlg = useMediaQuery(theme.breakpoints.up('lg'))
  let imageSize = theme.spacing(40)

  if (!matchlg) {
    imageSize = theme.spacing(30)
  }
  if (!matchMd) {
    imageSize = theme.spacing(20)
  }

  return (
    <Box
      id="cta2-section"
      sx={{ pt: { xs: 2, md: 4 }, pb: { xs: 2, md: 4 } }}
    >
      <Box
        sx={{
          px: 2, py: 2,
          color: "text.primary",
          textAlign: matchMd ? "left" : "center",
        }}
      >
        <Grid 
          container 
          alignItems="center" 
          spacing={matchMd ? 1 : 4} 
          justifyContent="space-between"
        >
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            {/*eslint-disable-next-line @next/next/no-img-element*/}
            <img
              alt=""
              width="100%"
              height={imageSize}
              src={`${GLOBAL_PATHS.COVERS}djotta-cards-cover.webp`}
              style={{borderRadius: "16px"}}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Typography align="center" component="div">
              <Chip
                label={
                  <Typography variant={matchMd ? "h4" : "h6"}>
                    {t('translation:cta2.title1')}
                  </Typography>
                }
                sx={{
                  height: 'auto',
                  color: "text.primary",
                  '& .MuiChip-label': { display: 'block', whiteSpace: 'normal' },
                }}
              />
              <Typography variant={matchMd ? "body1" : "body2"} sx={{ marginTop: "0.5rem" }}>
                {t('translation:cta2.content1')}
              </Typography>
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Typography align="center" component="div">
              <Chip
                label={
                  <Typography variant={matchMd ? "h4" : "h6"}>
                    {t('translation:cta2.title2')}
                  </Typography>
                }
                sx={{
                  height: 'auto',
                  color: "text.primary",
                  '& .MuiChip-label': { display: 'block', whiteSpace: 'normal' },
                }}
              />
              <Typography variant={matchMd ? "body1" : "body2"} sx={{ marginTop: "0.5rem" }}>
                Rejoignez notre programme de partenariat ARC et ensemble repoussons les limites de l'innovation.
              </Typography>
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            {/*eslint-disable-next-line @next/next/no-img-element*/}
            <img
              alt=""
              width="100%"
              height={imageSize}
              src={`${GLOBAL_PATHS.COVERS}djotta-partner.webp`}
              style={{borderRadius: "16px"}}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            {/*eslint-disable-next-line @next/next/no-img-element*/}
            <img
              alt=""
              width="100%"
              height={imageSize}
              src={`${GLOBAL_PATHS.COVERS}vcard-banner.webp`}
              style={{borderRadius: "16px"}}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Typography align="center" component="div">
              <Chip
                label={
                  <Typography variant={matchMd ? "h4" : "h6"}>
                    {t('translation:cta2.title3')}
                  </Typography>
                }
                sx={{
                  height: 'auto',
                  color: "text.primary",
                  '& .MuiChip-label': { display: 'block', whiteSpace: 'normal' },
                }}
              />
              <Typography variant={matchMd ? "body1" : "body2"} sx={{ marginTop: "0.5rem" }}>
                {t('translation:cta2.content3')}
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default Cta2Wrapper
